import $ from 'jquery';
import { Functions } from './helpers';
import { Header } from './components';
import { Menu } from './components';
import { Forms } from './components';
import { FormsFloating } from './components';
import { Dropdown } from './components';
import { DropdownMultiple } from './components';
import { Equalizer } from './components';
import { Slide } from './components';
import { Map } from './components';
import { Loader } from './components';
import { Popup } from './components';
import { Support } from './components';
// import { AccountGallery } from './components';
import { AccountDocuments } from "./components";
import { PurchaseOrderForm } from "./components";

export class App {

	constructor( settings ) {
		var _this = this;

		this.Win = typeof window !== 'undefined' ? window : this;
		this.Doc = this.Win.document;
		this.settings = settings;
		this.PwnCore = function() {
			this.lang                 = settings.lang;
			// this.startID              = startID;
			this.debugging            = settings.debugging;

			this.ReadyHandlers        = [];
			this.ResizeHandlers       = [];
			this.ScrollHandlers       = [];
			this.RAFHandlers          = []; // @todo Sadi: Request Animation Frame handlers

			// Globals

			this.window               = _this.Win;
			this.$window              = $( _this.Win );
			this.document             = _this.Doc;
			this.$document            = $( _this.Doc );
			this.$body                = null;

			// Flags
			this.initialized           = false;
			this.doingScroll           = false;
			this.doingResize           = false;
			this.doingAjax             = false;
			this.hasTouch              = false;
			this.load                  = false;
			this.ready                 = false;
			this.hashChanged           = false;
			this.viewportWidth         = 0;
			this.viewportHeight        = 0;
			this.viewportInitialHeight = 0;
			this.userAgent             = window.navigator.userAgent || window.navigator.vendor || window.opera;
			this.isFirefox             = /Firefox/i.test( this.userAgent );
			this.isChrome              = /Chrome/i.test( this.userAgent );
			this.isSafari              = /Safari/i.test( this.userAgent ) && ! this.isChrome;
			this.isMobile              = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test( this.userAgent );
			this.isIEMobile            = /IEMobile/i.test( this.userAgent );
			this.isFirefoxMobile       = ( this.isFirefox && this.isMobile );
			this.transform             = null;
			this.transition            = null;
			this.currentScroll         = 0;
			this.mastheadStuck         = 0;
			this.ResizeTimer           = null;
			this.Debounce              = 20;
			this.support = {
				file          : !! ( window.File && window.FileList && window.FileReader ),
				history       : !! ( window.history && window.history.pushState && window.history.replaceState ),
				matchMedia    : !! ( window.matchMedia || window.msMatchMedia ),
				pointer       : !! ( window.PointerEvent ),
				raf           : !! ( window.requestAnimationFrame && window.cancelAnimationFrame ),
				touch         : !! ( ( 'ontouchstart' in window ) || window.DocumentTouch && document instanceof window.DocumentTouch ),
				transition    : false,
				transform     : false
			}
		};
		this.PwnUI  = new this.PwnCore();
		this.$Ready = $.Deferred();

		this.$Ready.then( PwnUI => {
			if ( ! this.PwnUI.initialized ) {
				this.setup.call( document, this.PwnUI, this );
				this.PwnUI.initialized = true;
			}
		} );

		if ( this.PwnUI.debugging ) {
			console.log( 'init()', Functions.getCallTime() );
		}

		/**
		 * Event Window
		 *
		 * @scroll
		 * @resize
		 * @load
		 * @...
		 */
		this.PwnUI.$window
			.on( 'scroll.pwn', () => {
				this.onWindowScroll();
			} )
			.on( 'resize.pwn', () => {
				this.onWindowResize();
			} )
			.on( 'load.pwn',   () => {
				this.onWindowLoad();
			} );

		/**
		 * Event Window@resize
		 *
		 * Debounce the resize event on init
		 *
		 * @resize
		 */
		this.onWindowResize();

		/**
		 * Event Document
		 *
		 * @ready
		 */
		$( () => {
			this.PwnUI.$body = $( 'body' );

			this.$Ready.resolve();

			/**
			 * On ready or what?
			 */
			this.PwnUI.ready = !0;
		} );

		window.PwnUI = this.PwnUI;
	};

	inViewport( element, h ) {
		/**
		 * In viewport or not?
		 */
		var elementHeight = element.outerHeight(),
			scrolled = this.PwnUI.$window.scrollTop(),
			viewed = scrolled + this.PwnUI.viewportHeight,
			elementTop = element.offset().top,
			elementBottom = elementTop + elementHeight,
			// if 0, the element is considered in the viewport as soon as it enters.
			// if 1, the element is considered in the viewport only when it's fully inside
			// value in percentage (1 >= h >= 0)
			h = h || 0;

		return ( elementTop + elementHeight * h ) <= viewed && ( elementBottom - elementHeight * h ) >= scrolled;
	};

	sortPriority( a, b ) {
		return ( parseInt( a.priority ) - parseInt( b.priority ) );
	};

	onWindowScroll() {
		/**
		 * Doing scroll or what?
		 */
		this.PwnUI.doingScroll = !0;

		// Current scroll
		this.PwnUI.currentScroll = this.PwnUI.$window.scrollTop();

		for ( var i in this.PwnUI.ScrollHandlers ) {
			if ( this.PwnUI.ScrollHandlers.hasOwnProperty( i ) ) {
				this.PwnUI.ScrollHandlers[ i ].callback.call( window, this.PwnUI.viewportWidth, this.PwnUI.viewportHeight );
			}
		}

		// if ( this.PwnUI.debugging ) {
		// 	console.log( 'scroll()', Functions.getCallTime() );
		// }
	};

	onWindowResize() {
		this.PwnUI.viewportWidth  = this.PwnUI.$window.width();
		this.PwnUI.viewportHeight = this.PwnUI.$window.height();
		this.PwnUI.ResizeTimer    = Functions.startTimer( this.PwnUI.ResizeTimer, this.PwnUI.Debounce, this.handleWindowResize );
	};

	handleWindowResize() {
		for ( var i in this.PwnUI.ResizeHandlers ) {
			if ( this.PwnUI.ResizeHandlers.hasOwnProperty( i ) ) {
				this.PwnUI.ResizeHandlers[ i ].callback.call( window, this.PwnUI.viewportWidth, this.PwnUI.viewportHeight );
			}
		}

		if ( this.PwnUI.debugging ) {
			// console.log( 'resize()', Functions.getCallTime() );
		}
	};

	onWindowLoad() {
		/**
		 * On load or what?
		 */
		this.PwnUI.load = true;


		if ( this.PwnUI.debugging ) {
			console.log( 'load()', Functions.getCallTime() );
		}
	};

	setup( UI, App ) {

		/**
		 * Add iOS environment class
		 */
		if ( Functions.is_Android() ) {
			UI.$body.addClass( 'js-pwn-is-android' );
		}
		else if ( Functions.is_BlackBerry() ) {
			UI.$body.addClass( 'js-pwn-is-blackberry' );
		}
		else if ( Functions.is_iOS() ) {
			UI.$body.addClass( 'js-pwn-is-ios' );
		}
		else if ( Functions.is_Opera() ) {
			UI.$body.addClass( 'js-pwn-is-opera' );
		}
		else if ( Functions.is_Windows() ) {
			UI.$body.addClass( 'js-pwn-is-windows' );
		}
		else {
			UI.$body.addClass( 'js-pwn-is-any' );
		}

		// Ready handler
		UI.ReadyHandlers.push(
			// {
			// 	priority: 10,
			// 	callback: new Header( App )
			// },
			{
				priority: 20,
				callback: new Menu( App )
			},
			{
				priority: 30,
				callback: new Forms( App )
			},
			{
				priority: 40,
				callback: new FormsFloating( App )
			},
			{
				priority: 50,
				callback: new Dropdown( App )
			},
			/*{
				priority: 60,
				callback: new DropdownMultiple( App )
			},*/
			{
				priority: 70,
				callback: new Equalizer( App )
			},
			/*{
				priority: 80,
				callback: new SearchFilter( App )
			},*/
			{
				priority: 100,
				callback: new Slide( App )
			},
			{
				priority: 110,
				callback: new Map( App )
			},
			/*{
				priority: 120,
				callback: new LightboxGallery( App )
			},*/
			{
				priority: 130,
				callback: new Popup( App )
			},
			{
				priority: 140,
				callback: new AccountDocuments( App )
			},
            {
                priority: 150,
                callback: new PurchaseOrderForm(App)
            },
            {
                priority: 160,
                callback: new Support(App)
            }
			/*{
				priority: 140,
				callback: new Loader( App )
			},*/
		);

		// Sort ready handlers
		UI.ReadyHandlers.sort( App.sortPriority );

		// Resize handler
		UI.ResizeHandlers.push(
			// {
			// 	priority: 10,
			// 	callback: Header.resize
			// },
			{
				priority: 20,
				callback: Menu.resize
			},
			{
				priority: 30,
				callback: Slide.resize
			}
		);

		// Sort handlers on push
		UI.ResizeHandlers.sort( App.sortPriority );

		// Scroll handler
		UI.ScrollHandlers.push(
			// {
			// 	priority: 10,
			// 	callback: Header.check
			// }
			/*{
				priority: 10,
				callback: UI.goToTop
			}*/
		);

		// Sort handlers on push
		UI.ScrollHandlers.sort( App.sortPriority );

		if ( UI.debugging ) {
			console.log( 'setup()', Functions.getCallTime() );
		}
	};
}
